import React, { useCallback, useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import { SearchOutlined } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const Search = ({ getFiltered, refreshOnQueryChange = !getFiltered.autoRead }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("search") ?? "";
  const [filtered, setFiltered] = useState(query);
  const timerRef = useRef(null);
  const previousQueryRef = useRef(query);
  const { reFetch } = getFiltered;

  useEffect(() => {
    setFiltered(query);
    if (previousQueryRef.current !== query) {
      previousQueryRef.current = query;
      if (refreshOnQueryChange) reFetch();
    }
  }, [query, reFetch, refreshOnQueryChange]);

  const applySearch = useCallback((value) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (value) {
        next.set("search", value);
      } else {
        next.delete("search");
      }

      next.set("page", "1");
      return next;
    });
    if (value === query) reFetch();
  }, [query, reFetch, setSearchParams]);

  useEffect(() => {
    if (filtered === query) return undefined;
    timerRef.current = setTimeout(() => applySearch(filtered), 350);
    return () => clearTimeout(timerRef.current);
  }, [filtered, query, applySearch]);

  const handleSubmit = (event) => {
    event.preventDefault();
    clearTimeout(timerRef.current);
    applySearch(filtered);
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center">
      <TextField
        id="outlined-search"
        label="جستجو"
        type="search"
        onChange={(e) => setFiltered(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            "&:hover": {
              "& fieldset": {
                borderColor: "rgb(var(--c-primary))",
              },
            },
            "&.Mui-focused": {
              "& fieldset": {
                borderColor: "rgb(var(--c-primary))",
              },
            },
          },
          "& label.Mui-focused": {
            color: "rgb(var(--c-primary))",
          },
        }}
        value={filtered}
      />
      <button
        type="submit"
        aria-label="جستجو"
        className={`text-white !bg-primary hover:bg-primary-hover transition-all rounded-16 active:bg-primary-active focus:outline-none font-normal text-base rounded-l-card w-fit py-md px-8  `}
      >
        <SearchOutlined />
      </button>
    </form>
  );
};

export default Search;
